import type { ETA_OFFER_PLACEHOLDERS } from 'cpool-constants';
import { ETA_PLACEHOLDER } from 'cpool-constants';

import { formatCurrency } from './formatting/formatCurrency';
import { formatPercentage } from './formatting/formatPercentage';
import { formatResidualDebtInsurance } from './formatting/formatResidualDebtInsurance';
import { formatRuntime } from './formatting/formatRuntime';

export const getEtaContextForOffers = ({
    applicant1ResidualDebtInsurance,
    applicant2ResidualDebtInsurance,
    bank,
    creditAmount,
    disbursementAmount,
    freeText,
    interest,
    nominalInterest,
    rate,
    runtime,
}: {
    applicant1ResidualDebtInsurance: string[] | null | undefined;
    applicant2ResidualDebtInsurance: string[] | null | undefined;
    bank: string | null | undefined;
    creditAmount: number | null | undefined;
    disbursementAmount: number | null | undefined;
    freeText: () => string;
    interest: number | null | undefined;
    nominalInterest: number | null | undefined;
    rate: number | null | undefined;
    runtime: number | null | undefined;
}) => {
    return {
        [ETA_PLACEHOLDER.ANGEBOT_ABSICHERUNG_ANTRAGSTELLER_1]: formatResidualDebtInsurance(
            applicant1ResidualDebtInsurance ?? [],
        ),
        [ETA_PLACEHOLDER.ANGEBOT_ABSICHERUNG_ANTRAGSTELLER_2]: formatResidualDebtInsurance(
            applicant2ResidualDebtInsurance ?? null,
        ),
        [ETA_PLACEHOLDER.ANGEBOT_BANK]: bank ?? '-',
        [ETA_PLACEHOLDER.ANGEBOT_AUSZAHLUNGSBETRAG]: disbursementAmount ? formatCurrency(disbursementAmount) : '-',
        [ETA_PLACEHOLDER.ANGEBOT_EFFEKTIVZINSSATZ]: interest ? formatPercentage(interest) : '-',
        [ETA_PLACEHOLDER.ANGEBOT_KREDITBETRAG]: creditAmount ? formatCurrency(creditAmount) : '-',
        [ETA_PLACEHOLDER.ANGEBOT_LAUFZEIT]: runtime ? formatRuntime(runtime) : '-',
        [ETA_PLACEHOLDER.ANGEBOT_MONATLICHE_RATE]: rate ? formatCurrency(rate) : '-',
        [ETA_PLACEHOLDER.ANGEBOT_SOLLZINS]: nominalInterest ? formatPercentage(nominalInterest) : '-',
        [ETA_PLACEHOLDER.FREITEXT]: freeText,
    } satisfies {
        [key in ETA_OFFER_PLACEHOLDERS]: string | (() => string);
    };
};
